<template>
  <div class="base-select-option" v-click-outside="outsideClicked">
    <div
      ref="selectOption"
      class="base-select-option_input text-primary-1 input-color rounded-lg cursor-pointer"
      :class="mainClass"
      @click="selectOptionClicked"
    >
      <slot name="placeholder">
        <div class="flex items-center w-full justify-between gap-2">
          <span class="text-mobile-heading-6 md:text-heading-6">
            {{ option.title ? option.title : placeholder }}
          </span>
          <icon-chevron
            class="rotate-90 text-paragraph-2"
            :class="arrowClass"
          />
        </div>
      </slot>

      <transition name="collapse-sm">
        <div
          v-if="selectOptionStatus"
          ref="optionsContainer"
          :style="optionsPosition"
          class="base-select-option_options text-primary-1 text-heading-6 input-color absolute left-0 right-0 rounded-lg cursor-pointer z-10"
        >
          <slot name="options">
            <span
              v-for="item in options"
              :key="item.id"
              class="base-select-option_option"
              :class="{
                'base-select-option_option--active': item.id == option?.id,
              }"
              :title="item.title"
              @click.stop="updateOption(item)"
            >
              {{ item.title }}
            </span>
          </slot>
        </div>
      </transition>
    </div>
  </div>
</template>

<script setup lang="ts">
// @ts-nocheck
import { ref, watch, nextTick, onMounted, onBeforeUnmount } from "vue";
import type { IOptions } from "../../types/general";
import type { PropType } from "vue";

const props = defineProps({
  placeholder: {
    type: String,
    default: "",
  },
  mainClass: {
    type: String,
    default: "",
  },
  arrowClass: {
    type: String,
    default: "text-gray-1",
  },
  options: {
    type: Array as PropType<IOptions[]>,
    default: () => [
      {
        id: "",
        title: "",
      },
    ],
  },
  option: {
    type: Object,
    default: () => ({
      id: "",
      title: "",
    }),
  },
});

const selectOptionStatus = ref(false);
const optionsPosition = ref({});
const selectOption = ref(null);
const optionsContainer = ref(null);

function selectOptionClicked() {
  selectOptionStatus.value = !selectOptionStatus.value;
  if (selectOptionStatus.value) {
    nextTick(() => adjustOptionsPosition());
  }
}

const emit = defineEmits(["update:option"]);

function updateOption(val: IOptions) {
  emit("update:option", val);
  selectOptionStatus.value = false;
}

watch(selectOptionStatus, (newVal) => {
  if (newVal) {
    nextTick(() => adjustOptionsPosition());
  }
});

function adjustOptionsPosition() {
  const windowHeight = document.documentElement.clientHeight;
  const selectRect = selectOption.value?.getBoundingClientRect();
  if (selectRect) {
    const spaceBelow = windowHeight - selectRect.bottom;
    const spaceAbove = selectRect.top;
    if (spaceBelow < spaceAbove) {
      optionsPosition.value = {
        top: "auto",
        bottom: `${selectRect.height}px`,
      };
    } else {
      optionsPosition.value = {
        top: "100%",
        bottom: "auto",
      };
    }
  }
}

function handleScroll() {
  if (selectOptionStatus.value) {
    adjustOptionsPosition();
  }
}
function outsideClicked() {
  selectOptionStatus.value = false;
}
onMounted(() => {
  window.addEventListener("scroll", handleScroll, true);
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", handleScroll, true);
});
</script>
